// libs
import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

// Component
import LinedTitle from '../../../../tools/linedTitle/LinedTitle';
import Slide from '../slide/Slide';

// styles
import './styles.scss';

// proptypes & context
const propTypes = {
  content: PropTypes.array.isRequired,
};

const defaultProps = {};

const contextTypes = {
  t: PropTypes.func,
};


function Inspiration(props, { t }) {
  const {
    content,
  } = props;
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true,
          arrows: false,
          adaptiveHeight: true,
        },
      },
    ],
  };
  return (
    <section className="section inspiration">
      <LinedTitle title={t('pages.home.inspiration')} />
      {content &&
      <Slider {...settings}>
        {content.map((slide) =>
          <Slide key={`slide_${slide.diapo_title}`} content={slide} />,
        )}
      </Slider>
      }
    </section>
  );
}

Inspiration.propTypes = propTypes;
Inspiration.defaultProps = defaultProps;
Inspiration.contextTypes = contextTypes;

export default Inspiration;



// WEBPACK FOOTER //
// ./src/app/components/pages/home/parts/inspiration/Inspiration.js